<template>
  <div class="row mb-4" v-for="(ld, index) in listAspek" :key="ld.id">
    <div class="col-md-1 d-flex justify-content-center align-items-start">
      <span
        class=""
        style="font-size: 2rem; color: #dd3737; margin-left: 2rem"
        >{{ index + 1 }}</span
      >
    </div>
    <div class="col-md-11">
      <div class="row border rounded p-2 bg-white">
        <div
          class="col-md-1 d-flex justify-content-center align-items-center"
          v-if="['ADMIN', 'ENVIRONMENT'].some((r) => userData.role.includes(r))"
        >
          <font-awesome-icon
            icon="fa-solid fa-square-check text-secondary fa-xl"
            style="font-size: 2rem; color: #0c8953"
            class="text-center"
            v-if="(ld.approvedKustodian ?? []).length === (Object.keys(ld.kustodian ?? {})).length"
          />
          <font-awesome-icon
            icon="fa-solid fa-square-check text-secondary fa-xl"
            style="font-size: 2rem; color: #ffcc00"
            class="text-center"
            v-else-if="(ld.approvedKustodian ?? []).length !== (Object.keys(ld.kustodian ?? {})).length"
          />
          <font-awesome-icon
            icon="fa-solid fa-square-check text-secondary fa-xl"
            style="font-size: 2rem; color: #929292"
            class="text-center"
            v-else
          />
        </div>
        <div
          class="col-md-1 d-flex justify-content-center align-items-center"
          v-else
        >
          <font-awesome-icon
            icon="fa-solid fa-square-check text-secondary fa-xl"
            style="font-size: 2rem; color: #0c8953"
            class="text-center"
            v-if="(ld.approvedKustodian ?? []).includes(userData.id)"
          />
          <font-awesome-icon
            icon="fa-solid fa-square-check text-secondary fa-xl"
            style="font-size: 2rem; color: #929292"
            class="text-center"
            v-else
          />
        </div>

        <div class="col-md-9 d-flex align-items-center">
          <span class="align-middle">{{ ld.label }}</span>
        </div>

        <div class="col-md-2 d-flex justify-content-center align-items-center">
          <button
            type="button"
            class="btn btn_eform rounded border w-100"
            @click="toForm(ld.linkForm)"
            v-if="
              ld.kustodian != null && ld.kustodian?.[userData.id] !== undefined
            "
          >
            Isi Penilaian
          </button>
          <button
            type="button"
            class="btn btn_eform rounded border w-100"
            @click="toForm(ld.linkForm)"
            v-else-if="
              ['ADMIN', 'ENVIRONMENT'].some((r) => userData.role.includes(r))
            "
          >
            Lihat Penilaian
          </button>
        </div>
      </div>
    </div>
  </div>
  <!-- Loading overlay -->
  <div v-if="isLoading" class="loading-overlay">
    <!-- &lt;!&ndash; You can customize the loading content here (e.g., a spinner) &ndash;&gt; -->
    <div>
      <img
        src="@/assets/icons/Spinner-1s-200px.svg"
        style="height: 10rem"
        alt=""
      />
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "@/GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
// import axios from "axios";
// import Swal from "sweetalert2"
// import {
//     API_BASE_URL,
//     CMS_GET_ASPEKNILAI,

// } from "@/constants";
// const url_get_aspek = API_BASE_URL + CMS_GET_ASPEKNILAI;

export default {
  mixins: [GlobalDataMixin],
  name: "penilaianTeknis",
  components: {
    FontAwesomeIcon,
    // Datepicker
  },
  props: {
    dataPenilaianKompetensi: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      isLoading: true,
      listAspek: [],
      listLinkForm: [
        {
          id: 1,
          label: "Aspek Teknik & Inovasi",
          linkForm: "/materi/aspek-improvement",
        },
        {
          id: 2,
          label: "Aspek Keselamatan Pertambangan",
          linkForm: "/materi/aspek-keselamatan-pertambangan",
        },
        {
          id: 3,
          label: "Sistem Manajemen Keselamatan Pertambangan (SMKP)",

          linkForm: "/materi/aspek-smkp",
        },
        {
          id: 4,
          label: "Aspek Lingkungan Hidup",
          linkForm: "/materi/aspek-pengelolaan-lingkungan-hidup",
        },
        {
          id: 5,
          label: "Aspek Konservasi",
          linkForm: "/materi/aspek-konservasi",
        },
        {
          id: 6,
          label: "Aspek Standardisasi & Usaha Jasa",
          linkForm: "/materi/aspek-standarisasi-usaha-jaya",
        },
      ],
      // listDokumen: [
      //     {
      //         id: 'aspek-teknik-operasional',
      //         label: 'Aspek Teknik Operasional',
      //         linkForm: "/teknis/aspek-teknik-operasional",
      //     },
      //     {
      //         id: 'aspek-keselamatan-pertambangan',
      //         label: 'Aspek Keselamatan Pertambangan',
      //         linkForm: "/teknis/aspek-keselamatan-pertambangan",
      //     },
      //     {
      //         id: 'aspek-smkp',
      //         label: 'Aspek SMKP',
      //         linkForm: "/teknis/aspek-smkp",
      //     },
      //     {
      //         id: 'aspek-pengelolaan-lingkungan-hidup',
      //         label: 'Aspek Pengelolaan Lingkungan Hidup',
      //         linkForm: "/teknis/aspek-pengelolaan-lingkungan-hidup",
      //     },
      //     {
      //         id: 'aspek-konservasi',
      //         label: 'Aspek Konservasi',
      //         linkForm: "/teknis/aspek-konservasi",
      //     },
      //     {
      //         id: 'aspek-standarisasi-usaha-jaya',
      //         label: 'Aspek Standarisasi Usaha Jaya',
      //         linkForm: "/teknis/aspek-standarisasi-usaha-jaya",
      //     },
      //     {
      //         id: 'aspek-improvement',
      //         label: 'Aspek Improvement',
      //         linkForm: "/teknis/aspek-improvement",
      //     },
      // ],
    };
  },
  mounted() {
    this.getAspek();
    // Mendapatkan path URL saat ini
    // const currentPath = this.$router.currentRoute.value.path;

    // Mendapatkan parameter-parameter dari URL saat ini
    // const currentParams = this.$router.currentRoute.value.params;

    // console.log('Current Path:', currentPath);
    // console.log('Current Params:', currentParams);
  },
  computed: {},
  methods: {
    toForm(link) {
      const currentPath = this.$router.currentRoute.value.path;

      this.$router.push(currentPath + link);
    },
    getAspek() {
      let arr_list_aspek = [];

      for (let x = 0; x < this.dataPenilaianKompetensi.length; x++) {
        var el = this.dataPenilaianKompetensi[x];

        let lf = this.listLinkForm.filter((option) => option.id == el.idAspek);
        let linkform = lf.length != 0 ? lf[0].linkForm : null;
        linkform = "/aspek-teknis/" + el.idAspek; //hardcode aspekteknis
        arr_list_aspek.push({
          id: el.idAspek,
          label: el.aspek,
          linkForm: linkform,
          kustodian: el.listKustodian,
          approvedKustodian: el.approvedKustodian,
          namaKustodian: el.namaKustodian,
          skor: el.skor,
          skorMax: el.skorMax,
          catatan: el.catatan,
        });
      }
      this.isLoading = false;
      this.listAspek = arr_list_aspek;
      console.log(
        "this.dataPenilaianKompetensi:",
        this.dataPenilaianKompetensi
      );
      console.log("listAspek:", this.listAspek);
      //     let bodyJson = {}
      //     axios.post(url_get_aspek,
      //     bodyJson, {
      //         headers: {
      //         role: 'isafe',
      //         Authorization: "Bearer " + this.userData.token,
      //         accept: "*/*",
      //         },
      //     }
      //   )
      //   .then((response) => {

      //     console.log("response getAspek : ", response)
      //     // console.log("data : ", response.data)
      //     if(response!=null){
      //         let dta = response.data.data;
      //         let arr_list_aspek = []
      //         for (let i = 0; i < dta.length; i++) {
      //             let el = dta[i];
      //             let lf = this.listLinkForm.filter((option)=>option.id==el.id)
      //             let linkform = lf.length!=0?lf[0].linkForm:null;
      //             arr_list_aspek.push({
      //                 id:el.id,
      //                 label:el.aspekPenilaian,
      //                 linkForm:linkform
      //             })
      //         }
      //         this.listAspek = arr_list_aspek;
      //         this.isLoading = false;
      //     }
      //   })
      //   .catch((error) => {
      //     console.log("error getAspek : ", error)
      //     alert("error getAspek")
      //     this.isLoading = false;
      //   })
    },
  },
};
</script>

<style></style>
